module.exports = __webpack_public_path__ + "static/media/spaceship.fff978dd.png";